import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const SvgButton = props => {
  const [hover, setHover] = useState(false);

  const hoverOn = () => {
    setHover(true);
  };

  const hoverOff = () => {
    setHover(false);
  };

  const {
    btnWidth = 200,
    btnHeight = 40,
    btnHref,
    btnText = 'Button Text',
    btnFontSize = '0.9286rem',
    btnFontWeight = 400,
    btnTextColor = '#fff',
    btnArrow = true,
  } = props;

  let inputProps;
  const strokeDashArray = 2 * (Number(btnWidth) + Number(btnHeight));
  const btnStyles = {
    fontSize: btnFontSize,
    color: btnTextColor,
    height: btnHeight + 'px',
    width: btnWidth + 'px',
    fontWeight: btnFontWeight,
  };

  if (btnHref) {
    inputProps = {
      href: btnHref,
    };
  } else {
    inputProps = {
      onClick: props.controlFunc,
    };
  }

  return (
    <a
      {...inputProps}
      style={btnStyles}
      className={`svg-button
          ${btnArrow ? 'svg-button__icon-arrow' : 'svg-button--centered'}`}
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
      onFocus={hoverOn}
      onBlur={hoverOff}
    >
      <svg style={btnStyles} xmlns="http://www.w3.org/2000/svg">
        <rect
          className="svg-button__shape"
          height={btnHeight}
          width={btnWidth}
          strokeDasharray={strokeDashArray}
          strokeDashoffset={hover ? strokeDashArray : '0'}
        />
      </svg>
      <div className="svg-button__text" style={btnStyles}>
        {btnText}
      </div>
    </a>
  );
};

SvgButton.propTypes = {
  btnWidth: PropTypes.number,
  btnHeight: PropTypes.number,
  btnHref: PropTypes.string,
  controlFunc: PropTypes.func,
  btnText: PropTypes.string.isRequired,
  btnFontSize: PropTypes.string,
  btnFontWeight: PropTypes.number,
  btnTextColor: PropTypes.string,
  btnArrow: PropTypes.bool,
};

SvgButton.defaultProps = {
  btnArrow: false,
};

export default SvgButton;
